// Module
var code = "<modal title=\"{{'Remove Tags' | translate}}\" cancel=$hide() hide-footer=true> <p translate>Click on a tag to remove it from selected contacts:</p> <ul> <li ng-repeat=\"tag in $ctrl.tags\"> <a href=javascript:; ng-click=$ctrl.removeTag(tag)>{{ tag }}</a> </li> </ul> </modal> ";
// Exports
module.exports = code;